import React from 'react'
import clsx from 'clsx'
import { Button } from '@material-ui/core'
import ViewModuleIcon from '@material-ui/icons/ViewModule'
import ViewListIcon from '@material-ui/icons/ViewList'
import { useStyles } from './ViewModeToggle.styles'

export const ViewModeToggle = ({ viewMode, setViewMode }) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Button
        size="small"
        className={clsx(classes.toggleButton, {
          [classes.activeButton]: viewMode === 'grid',
          [classes.inactiveButton]: viewMode !== 'grid',
        })}
        onClick={() => setViewMode('grid')}
      >
        <ViewModuleIcon fontSize="small" />
      </Button>
      <Button
        size="small"
        className={clsx(classes.toggleButton, {
          [classes.activeButton]: viewMode === 'list',
          [classes.inactiveButton]: viewMode !== 'list',
        })}
        onClick={() => setViewMode('list')}
      >
        <ViewListIcon fontSize="small" />
      </Button>
    </div>
  )
}
